import React from 'react';
import { AppBar, Toolbar, Typography, IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

const TLHHeaderComponent = ({ sidebarOpen, onToggleSidebar }) => {
  return (
    <>
      <AppBar position="static">
        <Toolbar>
          {onToggleSidebar && (
            <IconButton
              color="inherit"
              onClick={onToggleSidebar}
              edge="start"
              sx={{ mr: 4 }}
            >
              {sidebarOpen ? <MenuOpenIcon /> : <MenuIcon />}
            </IconButton>
          )}
          <Typography variant="h6" component="div">
            The Learning Hub
          </Typography>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default TLHHeaderComponent;
